export var GetExceptionlsinMapper = function (data) {
    var result = {};
    if (data && data.length > 0) {
        result = data.map(function (item) {
            return {
                v_isin: item.v_isin,
                v_scripcode: item.v_scripcode,
                v_scrip_name: item.v_scrip_name,
            };
        });
    }
    return result;
};
